import differenceInSeconds from "date-fns/differenceInSeconds";




export const secondsSince = (date, now = new Date()) => {
    return differenceInSeconds(now, new Date(date));
}




export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}


export const getDefaultData = (type = `text`) => {
    if (type === 'image')
        return {
            id: "id" + Math.random().toString(16).slice(2),
            type: 'image',
            data: 'https://scaffoldingversion.s3.ap-southeast-1.amazonaws.com/public/images/approval/2022/Dec/29/63ad23bb2a13e.png',
            left: 0,
            top: 0,
            width: 400,
            height: 300
        }
    else return {
        id: "id" + Math.random().toString(16).slice(2),
        type: 'text',
        data: 'Test',
        left: 0,
        top: 0,
        width: 400,
        height: 300
    };
}


export const getDefaultDataAll = () => {
    return [
        {
            id: 1,
            type: 'image',
            data: 'https://scaffoldingversion.s3.ap-southeast-1.amazonaws.com/public/images/approval/2022/Dec/29/63ad23bb2a13e.png',
            left: 0,
            top: 0,
            width: 400,
            height: 300
        },
        {
            id: 2,
            type: 'text',
            data: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
            left: 500,
            top: 0,
            width: 400,
            height: 300
        }];
}


export const isInArrayFunction = (value, array) => {
    return array.indexOf(value) > -1;
}

